export default function CElse() {
  return <h2>C Else</h2>;
}
